import client from './client';
import { allPages } from './allPages';

import {
  Questionnaire,
  QuestionnaireCreate,
  QuestionnaireDetail,
  QuestionnaireListResponse,
  QuestionnaireUpdate,
} from './questionnaire.types';

// =============================================================================
// API Functions - Questionnaire Management (Admin)
// =============================================================================

export async function getQuestionnaires(
  tenantId: number,
  options?: { skip?: number; limit?: number; includeInactive?: boolean },
): Promise<QuestionnaireListResponse> {
  const params = new URLSearchParams();
  params.append('tenantId', tenantId.toString());
  if (options?.skip !== undefined) params.append('skip', options.skip.toString());
  if (options?.limit !== undefined) params.append('limit', options.limit.toString());
  if (options?.includeInactive) params.append('includeInactive', 'true');

  const response = await client.get<QuestionnaireListResponse>(
    `/questionnaires?${params.toString()}`,
  );
  return response.data;
}

/** Every questionnaire of a tenant, the inactive ones too. */
export const getAllQuestionnaires = (tenantId: number): Promise<Questionnaire[]> =>
  allPages((skip, limit) =>
    getQuestionnaires(tenantId, { skip, limit, includeInactive: true }).then((page) => page.questionnaires),
  );

export async function getQuestionnaire(
  questionnaireId: number,
): Promise<QuestionnaireDetail> {
  const response = await client.get<QuestionnaireDetail>(
    `/questionnaires/${questionnaireId}`,
  );
  return response.data;
}

export async function createQuestionnaire(
  data: QuestionnaireCreate,
): Promise<Questionnaire> {
  const response = await client.post<Questionnaire>('/questionnaires', data);
  return response.data;
}

export async function updateQuestionnaire(
  questionnaireId: number,
  data: QuestionnaireUpdate,
): Promise<Questionnaire> {
  const response = await client.put<Questionnaire>(
    `/questionnaires/${questionnaireId}`,
    data,
  );
  return response.data;
}

export async function deleteQuestionnaire(
  questionnaireId: number,
): Promise<void> {
  await client.delete(`/questionnaires/${questionnaireId}`);
}

export async function regeneratePublicLink(
  questionnaireId: number,
): Promise<Questionnaire> {
  const response = await client.post<Questionnaire>(
    `/questionnaires/${questionnaireId}/regenerate-link`,
    {},
  );
  return response.data;
}
